import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from 'semantic-ui-react';
import Location from '../../../../molecules/Location';
import Call from '../../../../molecules/Call';
import Email from '../../../../molecules/Email';
import HoursOfOperation from '../../../../molecules/HoursOfOperation';

const SimpleBody = props => {
  const {
    contactInformation: { address, phoneNumber, email },
    pages,
    hours,
    ctas,
    bodyColor,
    locationClassName,
    phoneNumberClassName,
    emailClassName,
    hoursClassName,
  } = props;
  const columns = hours.length === 0 ? 0 : 1 + pages.length + 1;
  const WorkHoursColumn = () =>
    hours.length === 0 ? null : (
      <Grid.Column computer={4} tablet={5}>
        <HoursOfOperation hours={hours} displayOption="grouped" className={hoursClassName} />
      </Grid.Column>
    );

  const CtasSection = () =>
    ctas.length === 3 ? (
      <Grid.Row>
        <Grid.Column width={2} only="tablet computer" />
        <Grid.Column width={3} verticalAlign="middle">
          <Button primary as="a" href={`#${ctas[0].link}`} size="medium" fluid>
            {ctas[0].text}
          </Button>
        </Grid.Column>
        <Grid.Column width={1} only="tablet computer" />
        <Grid.Column width={4}>
          <Button primary as="a" href={`#${ctas[1].link}`} size="big" fluid>
            {ctas[1].text}
          </Button>
        </Grid.Column>
        <Grid.Column width={1} only="tablet computer" />
        <Grid.Column width={3} verticalAlign="middle">
          <Button primary as="a" href={`#${ctas[2].link}`} size="medium" fluid>
            {ctas[2].text}
          </Button>
        </Grid.Column>
        <Grid.Column width={2} only="tablet computer" />
      </Grid.Row>
    ) : (
      ctas.length === 2 && (
        <Grid.Row>
          <Grid.Column width={3} only="tablet computer" />
          <Grid.Column width={4} verticalAlign="middle">
            <Button primary as="a" href={`#${ctas[0].link}`} size="medium" fluid>
              {ctas[0].text}
            </Button>
          </Grid.Column>
          <Grid.Column width={2} only="tablet computer" />
          <Grid.Column width={4}>
            <Button primary as="a" href={`#${ctas[1].link}`} size="big" fluid>
              {ctas[1].text}
            </Button>
          </Grid.Column>
          <Grid.Column width={3} only="tablet computer" />
        </Grid.Row>
      )
    );

  const LocationColumn = () => (
    <Grid.Column computer={4} tablet={5} textAlign="center">
      <Location address={address} showIcon className={locationClassName} />
      <Call phoneNumber={phoneNumber} showIcon className={phoneNumberClassName} />
      {email && <Email email={email} showIcon className={emailClassName} />}
    </Grid.Column>
  );

  const MainSection = () => (
    <Grid.Row columns={columns}>
      <Grid.Column width={1} only="tablet computer" />
      <LocationColumn />
      <Grid.Column computer={6} tablet={4} />
      <WorkHoursColumn />
      <Grid.Column width={1} only="tablet computer" />
    </Grid.Row>
  );

  return (
    <div style={{ backgroundColor: bodyColor, paddingTop: '3em', paddingBottom: '2em' }}>
      <Grid stackable>
        <MainSection />
        <CtasSection />
      </Grid>
    </div>
  );
};

SimpleBody.propTypes = {
  bodyColor: PropTypes.string.isRequired,
  locationClassName: PropTypes.string,
  phoneNumberClassName: PropTypes.string,
  emailClassName: PropTypes.string,
  hoursClassName: PropTypes.string,
};
SimpleBody.defaultProps = {
  locationClassName: 'footer-location-info',
  phoneNumberClassName: 'footer-phone-number',
  emailClassName: 'footer-email-address',
  hoursClassName: 'footer-hoo',
};

export default SimpleBody;
